import styled from '@emotion/styled';
import { theme } from '../../constants/theme';

const variantColors = {
  default: {
    bg: theme.colors.gray[200],
    text: theme.colors.text.primary,
    border: theme.colors.gray[300],
  },
  primary: {
    bg: theme.colors.primary.main,
    text: theme.colors.white,
    border: theme.colors.primary.dark,
  },
  secondary: {
    bg: theme.colors.secondary.main,
    text: theme.colors.white,
    border: theme.colors.secondary.dark,
  },
  success: {
    bg: theme.colors.success.main,
    text: theme.colors.white,
    border: theme.colors.success.dark,
  },
  error: {
    bg: theme.colors.error.main,
    text: theme.colors.white,
    border: theme.colors.error.dark,
  },
  warning: {
    bg: '#ff9800',
    text: theme.colors.white,
    border: '#f57c00',
  },
  info: {
    bg: '#2196f3',
    text: theme.colors.white,
    border: '#1976d2',
  },
};

export const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: ${theme.typography.fontWeight.semibold};
  line-height: 1;
  white-space: nowrap;
  transition: ${theme.transitions.duration.fast} ${theme.transitions.timing.easeInOut};

  /* Size variants */
  ${props => {
    if (props.$dot) {
      const dotSizes = {
        sm: '6px',
        md: '8px',
        lg: '10px',
      };
      return `
        width: ${dotSizes[props.$size]};
        height: ${dotSizes[props.$size]};
        padding: 0;
        border-radius: 50%;
      `;
    }

    const sizes = {
      sm: `
        padding: ${theme.spacing.xs} ${theme.spacing.sm};
        font-size: ${theme.typography.fontSize.xs};
        min-width: 1.25rem;
        height: 1.25rem;
      `,
      md: `
        padding: ${theme.spacing.xs} ${theme.spacing.md};
        font-size: ${theme.typography.fontSize.sm};
        min-width: 1.5rem;
        height: 1.5rem;
      `,
      lg: `
        padding: ${theme.spacing.sm} ${theme.spacing.md};
        font-size: ${theme.typography.fontSize.md};
        min-width: 2rem;
        height: 2rem;
      `,
    };
    return sizes[props.$size] || sizes.md;
  }}

  /* Border radius */
  border-radius: ${props => props.$pill ? '9999px' : theme.borderRadius.sm};

  /* Color variants */
  ${props => {
    const colors = variantColors[props.$variant] || variantColors.default;
    
    if (props.$outlined) {
      return `
        background-color: transparent;
        color: ${colors.bg};
        border: 1px solid ${colors.bg};
      `;
    }
    
    return `
      background-color: ${colors.bg};
      color: ${colors.text};
      border: 1px solid transparent;
    `;
  }}

  /* Hover effect for clickable badges */
  &:hover {
    opacity: 0.9;
  }
`;
